module.exports = __webpack_public_path__ + "img/translate-two.5bb92731.png";